<!-- eslint-disable vue/no-mutating-props -->
<template>

 


<div class="nk-block-head">
  <div class="nk-block-head-content">
    <h5 class="nk-block-title" v-if="formIslem === 'ekle'">Yeni Etkinlik  Ekle</h5>
    <h5 class="nk-block-title" v-if="formIslem === 'duzenle'">Etkinlik  Düzenleme</h5>
    <div class="nk-block-des"><p>Etkinlikler</p></div>
  </div>
</div>

  <form @submit.prevent="gonder">

    <div class="row">
   
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.ad }">
        <div class="col-lg-3">
          <label for="ad" class="form-label">Ad</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="ad" v-model="localFormData.ad" >
        <span v-if="formHatalar.ad" class="error">{{ formHatalar.ad }}</span>
        </div>
      </div>
    
    
    
    <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.bastarih }">
        <div class="col-lg-3">
          <label for="bastarih"  class="form-label">Başlama Tarihi</label> 
        </div>
        <div class="col-lg-9">
          <VueCtkDateTimePicker 
        v-model="localFormData.bastarih" 
        format="YYYY-MM-DD HH:mm:ss"
        label="Başlama Tarihi Seçiniz"
        button-now-translation="Bugün"
        />
        <span v-if="formHatalar.bastarih" class="error">{{ formHatalar.bastarih }}</span>
        </div>
      </div>
    
    <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.bittarih }">
        <div class="col-lg-3">
          <label for="bittarih" class="form-label">Bitiş Tarihi</label> 
        </div>
        <div class="col-lg-9">
          <VueCtkDateTimePicker 
        v-model="localFormData.bittarih" 
        format="YYYY-MM-DD HH:mm:ss"
        label="Bitiş Tarihi Seçiniz"
        button-now-translation="Bugün"
        />
        <span v-if="formHatalar.bittarih" class="error">{{ formHatalar.bittarih }}</span>
        </div>
      </div>
    
    
    
    
    <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.logo }"> 
       
        <picture-input 
          ref="profil"
          width="600" 
          height="600" 
          margin="16" 
          accept="image/jpeg,image/png" 
          size="10" 
          button-class="btn"
          :custom-strings="{
            upload: '<h1>Logo</h1>',
            drag: 'Tıklayın veya sürükleyip bırakın'
          }"
          @change="logoDegistir">
        </picture-input>
      </div>	
        <span v-if="formHatalar.logo" class="error">{{ formHatalar.logo }}</span>
   
    
    
    

     
    </div>

    


 

    <div class="d-flex justify-content-around  mt-4"> 
      
      <button type="button" class="btn btn-light  mr-2" @click="iptalEt"><em class="icon ni ni-cross"></em><span>İptal Et</span></button>
      <button type="submit" class="btn btn-primary"><em class="icon ni ni-check"></em><span>Kaydet</span></button>
    </div>
  </form>

</template>

<script>
import axiosCustom from "@/services/axiosCustom";




import PictureInput from 'vue-picture-input'



import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';



export default {
components: {
  
  
  
    PictureInput,
  
  
  
    VueCtkDateTimePicker,
  
  
},
props: {
  formIslem: String,
  formData: Object,
  formKaydetSonrasi: Function,
  formIptal: Function,

},
data() {
  return {
    
    logoSecili: null,
    
    
  

  
    localFormData: { ...this.formData }, 
    formHatalar:{},

    

  };
},
created() {
  
   

  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

  
          
          
          
         
          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },
    },
methods: {
  
  



  formDogrula() {
    this.formHatalar = {};
    var kontrol=true;
    
    
    if (!this.localFormData.ad) {
      this.formHatalar.ad = "Ad boş bırakılamaz.";
      kontrol=false;
    }
    
    
  
  
   
  
   
  
  
   
 


    return kontrol;
  },
  async  gonder() {
    if(this.formDogrula()){
  // FormData oluştur
  const newFormData = new FormData();
  newFormData.append("ad", this.localFormData.ad ?? '');
  
  newFormData.append("bastarih", this.localFormData.bastarih );newFormData.append("bittarih", this.localFormData.bittarih);
  
   
  newFormData.append("logo",  this.logoSecili );
  

  try {
  if (this.formIslem === "duzenle") {
    axiosCustom
      .post("etkinlikler/duzenle/" + this.localFormData.id, newFormData)
      .then(() => {
        

        this.$toast.success("Etkinlik Düzenlendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Güncelleme hatası: ", error);
        this.$toast.error("Güncelleme hatası");
      });
  } else {
    axiosCustom
      .post("etkinlikler/ekle", newFormData)
      .then(() => {
        

        this.$toast.success("Yeni Etkinlik Eklendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Ekleme hatası: ", error);
        this.$toast.error("Ekleme hatası");
      });
  }
} catch (error) {
    console.error('Kaydetme hatası: ', error);
    this.$toast.error('Kaydetme hatası');
  }
} 
  },
  
  iptalEt() {
    this.formIptal();
  },

  

  
  logoDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.logoSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.logoSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.logoOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.logoSecili);
        }
    },
    
},
};
</script>